// 機材管理サブシステム（号機・個体・メンテナンス記録・割当。設計 F1 §7）。ルート名はアシスタントの SCREENS と同じ
const meta = (menu) => ({ requiresAuth: true, requiresBizhub: true, ...(menu ? { menu } : {}) });
export default [
  { path: "equipment/sets", name: "BizhubEquipmentSets", component: () => import("@/views/Bizhub/EquipmentSetListView.vue"),
    meta: meta({ group: "機材管理", title: "号機一覧", order: 10 }) },
  { path: "equipment/sets/:id", name: "BizhubEquipmentSetDetail", component: () => import("@/views/Bizhub/EquipmentSetDetailView.vue"), meta: meta() },
  { path: "equipment/calendar", name: "BizhubEquipmentCalendar", component: () => import("@/views/Bizhub/EquipmentCalendarView.vue"),
    meta: meta({ group: "機材管理", title: "機材カレンダー", order: 20 }) },
  { path: "equipment/items", name: "BizhubEquipmentItems", component: () => import("@/views/Bizhub/EquipmentItemListView.vue"),
    meta: meta({ group: "機材管理", title: "個体一覧", order: 30 }) },
  { path: "equipment/inventory", name: "BizhubEquipmentInventory", component: () => import("@/views/Bizhub/EquipmentInventoryView.vue"),
    meta: meta({ group: "機材管理", title: "棚卸し", order: 40 }) },
];
